import React, { MouseEventHandler } from "react";
import { BaseCard, CardProps } from "../../../BaseCard";
import { CtaButton } from "../../../../components/CtaButton";
import { Description } from "../../../../components/Description";
import { Title } from "../../../../components/Title";
import { AlignedContent } from "../../../../styles";
import { ButtonContainer } from "../../../FormCard/styles";

type Props = CardProps & {
  isGradedQuiz: boolean;
  isSurvey: boolean;
  isStarted: boolean;
  surveyStr?: string;
  practiceStr?: string;
  gradedQuizReqsStr?: string;
  startStr?: string;
  resumeStr?: string;
  title?: string | null;
  onStartForm: MouseEventHandler<HTMLButtonElement>;
};

// TODO: Migrate this to composite pattern
export function IntroCardv2({
  isActive,
  isGradedQuiz,
  isStarted,
  isSurvey,
  surveyStr = "Survey",
  practiceStr = "Practice",
  gradedQuizReqsStr,
  startStr = "Start",
  title,
  resumeStr = "Resume",
  onStartForm,
  onCardActive,
}: Props) {
  return (
    <BaseCard isActive={isActive} onCardActive={onCardActive}>
      <AlignedContent $align="center">
        <Title text={title || (isSurvey ? surveyStr : practiceStr)} />
        {isGradedQuiz && <Description text={gradedQuizReqsStr} />}
        <ButtonContainer>
          <CtaButton
            text={isStarted ? resumeStr : startStr}
            onClick={onStartForm}
          />
        </ButtonContainer>
      </AlignedContent>
    </BaseCard>
  );
}
